import Loadable from 'react-loadable';

import { Loading } from '../../common/navigation';


const SchoolPsychologyRequest = Loadable({
    loader: () => import('./components/school-psychology-request'),
    loading: Loading,
  });


export const routes = [
    {
      path: '/school-psychology-request',
      exact: true,
      name: 'school-psychology-request',
      component: SchoolPsychologyRequest,
    },
  ];
  